import { render } from "./IpAddressesTab.vue?vue&type=template&id=73d58735&scoped=true"
import script from "./IpAddressesTab.vue?vue&type=script&lang=js"
export * from "./IpAddressesTab.vue?vue&type=script&lang=js"

import "./IpAddressesTab.vue?vue&type=style&index=0&id=73d58735&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d58735"]])

export default __exports__